import { BaseLogin } from './login';
import { alertError } from "@cems-eco/core/src/utils/widget";
import router from "@/router";
import { ElLoading } from 'element-plus';

export class DemoLoginPage extends BaseLogin {
    async created() {
        this.login.value.email = "admin@ada-ir.com";
        this.login.value.password = "password";
    }

    async authenticate() {
        const loader = ElLoading.service({ lock: true });
        try {
            loader.close();
            router.replace('/auth/site');
        } catch (e) {
            loader.close();
            alertError(e);
        }
    }
}

